import { Box, Button, Grid, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { GridSkeleton, SkeletonTable, SkeletonText } from "../ProfileTabPage";
import KontakDaruratModal from "./Components/KontakDaruratModal";
import KontakDaruratTable from "./Components/KontakDaruratTable";
import { LoadingOverlay } from "../../../components/LoadingOverlay";
import useFetchAllKontakDarurat from "./../../../api/effects/queries/KontakDarurat/useFetchAllKontakDarurat";


const TitleGrid = styled(Grid)(({ theme }) => ({
    paddingLeft: "5%",
    paddingBottom: "1%",
    paddingTop: "1%",
}));

const ButtonGrid = styled(Grid)(({ theme }) => ({
    paddingRight: "5%",
    paddingBottom: "1%",
    paddingTop: "1%",
}));

export default function KontakDaruratPage() {
    const [modalStateKontakDarurat, setModalStateKontakDarurat] = useState(false);
    const [kontakDarurat, setKontakDarurat] = useState("");

    const handleCloseModalKontakDarurat = () => {
        setModalStateKontakDarurat(false);
    };

    const handleOpenModalKontakDarurat = () => {
        setModalStateKontakDarurat(true);
    };

    // const [loading, setLoading] = useState(true);
    // useEffect(() => {
    //     setLoading(false);
    // }, []);

    // if (loading) {
    //     return (
    //         <GridSkeleton justifyContent="center" alignItems="center">
    //             <SkeletonText variant="text" />
    //             <SkeletonTable variant="rectangular" />
    //         </GridSkeleton>
    //     );
    // }

    const { data: kontakDaruratData, isLoading: isKontakDaruratLoading } = useFetchAllKontakDarurat();
    const pageIsLoading = isKontakDaruratLoading;

    return (
        <Box>
            <KontakDaruratModal
                ID={-1}
                open={modalStateKontakDarurat}
                handleClose={handleCloseModalKontakDarurat}
            />
            <LoadingOverlay isLoading={pageIsLoading}>
                <TitleGrid container item xs={12} justifyContent="flex-start">
                    <Typography variant="h5">
                        Kontak Darurat
                    </Typography>
                </TitleGrid>
                <KontakDaruratTable />
                <ButtonGrid container item xs={12} justifyContent="flex-end">
                    <Button variant="contained" onClick={handleOpenModalKontakDarurat}>
                        Tambah Kontak Darurat
                    </Button>
                </ButtonGrid>
            </LoadingOverlay>
        </Box>
    );
}